export const  BASE_URL='https://vtasrilanka.azurewebsites.net'